// extracted by mini-css-extract-plugin
export default {"cents":"FormattedTextPrice_cents__OAlmz"};